export default class LoginFormModel {
  username = ''

  password = ''

  keepUserLoggedIn = true
}
